export interface KngLoader {
  state: KngLoaderState;
}
export interface KngLoaderState {
  imagePath: string;
}
